import { render } from "./Difference.vue?vue&type=template&id=0c68ecb5"
import script from "./Difference.vue?vue&type=script&lang=js"
export * from "./Difference.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__